module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-project-stages-completion-d7479f8f63a4264f4b779cb10073db22.png";